import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/comics';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Testimonials */}
        <div className="mb-16">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              用户口碑
            </h2>
            <p className="text-foreground-500 text-sm">听听漫画爱好者们怎么说</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {testimonials.map((t) => (
              <div
                key={t.id}
                className="p-5 rounded-xl bg-background-50 border border-background-200"
              >
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-[10px] text-amber-500"></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-4">
                  {t.content}
                </p>
                <p className="text-[10px] text-foreground-300 mt-3">{t.date}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Banner */}
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20beautiful%20illustration%20of%20a%20cozy%20reading%20nook%20with%20a%20tablet%20displaying%20a%20colorful%20manga%20page%2C%20warm%20lamp%20light%2C%20surrounded%20by%20bookshelves%20filled%20with%20comic%20books%2C%20soft%20ambient%20glow%2C%20inviting%20atmosphere%2C%20digital%20art%20style%20with%20rich%20warm%20tones&width=1680&height=500&seq=cta-banner-2026&orientation=landscape"
            alt="加入奇妙漫画，开启阅读之旅"
            className="w-full h-48 md:h-64 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent flex items-center">
            <div className="px-6 md:px-12 py-8 max-w-lg">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-3">
                准备好开始你的漫画之旅了吗？
              </h3>
              <p className="text-white/70 text-sm mb-5">
                加入奇妙漫画，百万漫画免费看，随时随地畅享阅读乐趣！
              </p>
              <Link
                to="/category"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-full transition-colors whitespace-nowrap"
              >
                <i className="ri-play-circle-line"></i>
                立即开始阅读
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}